<template>
  <div v-if="foundriesOptions.options.length > 1" class="fou-font-dropdown">
    <div class="fou-select-foundry">
      <VSelect
        :id="$vId(this, 'dashboard-foundry')"
        ref="foundrySelectRef"
        v-model="foundriesOptions.values"
        tabindex="0"
        :initial-value="foundriesOptions.values"
        :options="foundriesOptions.options"
        :reduce="op => op"
        :placeholder="$t('pages.profile.enter_defaultFoundry')"
        :show-error-message="false"
        type="radio"
        :searchable="false"
        rules="required"
        input-class="full-width"
        name="foundry"
      />
    </div>
  </div>
  <div v-if="foundriesOptions.options.length === 1" class="foundry-name">{{ foundriesOptions.options[0].label }}</div>
</template>

<script src="./script.js"></script>
